import { useEffect, useState } from 'react';
import { s, authHeaders } from '../listPageStyles';
import { deriveCampaignKind, csvToArr } from './campaignUtils';

export function CampaignCombinationsModal({ campaignId, form, onClose, onGoToRestrictions }) {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetch('/api/campaigns?take=500', { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => {
        const data = (p && (p.Data || p.data)) || p || {};
        const items = data.items || data.Items || [];
        if (alive) setCampaigns(Array.isArray(items) ? items : []);
      })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const selfConflicts = new Set(csvToArr(form.conflictingCampaignIdsCsv));
  const others = campaigns.filter((c) => (c.id || c.Id) !== campaignId);

  const evaluate = (c) => {
    const cid = c.id || c.Id;
    const otherConflicts = new Set(csvToArr(c.conflictingCampaignIdsCsv || c.ConflictingCampaignIdsCsv));
    const otherCombinable = (c.isCombinable ?? c.IsCombinable) !== false;
    const ok = !!form.isCombinable && otherCombinable && !selfConflicts.has(cid) && !(campaignId && otherConflicts.has(campaignId));
    return ok;
  };

  const compatible = others.filter(evaluate);
  const incompatible = others.filter((c) => !evaluate(c));
  const kind = deriveCampaignKind(form);

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={{ ...s.modal, maxWidth: 860 }} onClick={(e) => e.stopPropagation()}>
        <div style={s.modalHeader}>
          <h3 style={s.modalTitle}>Kampanya Kombinasyonları</h3>
          <button style={s.closeBtn} onClick={onClose}>×</button>
        </div>
        <div style={s.modalBody}>
          {/* Bu kampanya */}
          <div style={{ border: '1px solid var(--border-color,#e5e7eb)', borderRadius: 12, padding: 14, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 10 }}>
            <strong style={{ fontSize: 15 }}>{form.name || 'Bu kampanya'}</strong>
            <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 999, background: '#1e3a8a', color: '#fff', fontWeight: 700 }}>{kind.label}</span>
            <span style={{ fontSize: 12, color: 'var(--text-secondary,#6b7280)' }}>Öncelik: {form.priority || 0}</span>
            <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 999, background: form.isCombinable ? '#15803d' : '#b91c1c', color: '#fff' }}>
              {form.isCombinable ? 'KOMBİNE EDİLEBİLİR' : 'TEK BAŞINA'}
            </span>
          </div>

          {loading ? (
            <div className="cmp-empty">Yükleniyor…</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <div style={{ border: '1px solid rgba(21,128,61,0.3)', borderRadius: 12, padding: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d', marginBottom: 8 }}>Birlikte Uygulanabilir ({compatible.length})</div>
                {compatible.length ? compatible.map((c) => (
                  <div key={c.id || c.Id} style={{ padding: '6px 0', borderTop: '1px solid #f1f5f9', fontSize: 13 }}>
                    {c.name || c.Name}
                    <div style={{ fontSize: 11, color: 'var(--text-secondary,#6b7280)' }}>{deriveCampaignKind(c).label}</div>
                  </div>
                )) : <div className="cmp-empty" style={{ padding: 12 }}>—</div>}
              </div>
              <div style={{ border: '1px solid rgba(185,28,28,0.3)', borderRadius: 12, padding: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#b91c1c', marginBottom: 8 }}>Çakışan / Uyumsuz ({incompatible.length})</div>
                {incompatible.length ? incompatible.map((c) => (
                  <div key={c.id || c.Id} style={{ padding: '6px 0', borderTop: '1px solid #f1f5f9', fontSize: 13 }}>
                    {c.name || c.Name}
                    <div style={{ fontSize: 11, color: 'var(--text-secondary,#6b7280)' }}>{deriveCampaignKind(c).label}</div>
                  </div>
                )) : <div className="cmp-empty" style={{ padding: 12 }}>Tüm kampanyalarla uyumlu!</div>}
              </div>
            </div>
          )}
          <p style={{ fontSize: 12, color: 'var(--text-secondary,#6b7280)', marginTop: 12, marginBottom: 0 }}>
            ⓘ Müşteri sepetinde bu kampanyalar birlikte uygulanabilir. Öncelik sırasına göre hesaplanır.
          </p>
        </div>
        <div style={s.modalFooter}>
          <button style={s.btnPrimary} onClick={onGoToRestrictions}>Kısıtlamaları Düzenle</button>
          <button style={s.btnSecondary} onClick={onClose}>Kapat</button>
        </div>
      </div>
    </div>
  );
}

export default CampaignCombinationsModal;
